import { render, staticRenderFns } from "./CustodyInfo.vue?vue&type=template&id=46d6056a&"
import script from "./CustodyInfo.vue?vue&type=script&lang=js&"
export * from "./CustodyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports